import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "placement"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
var TooltipWrapper = function TooltipWrapper(_ref) {
  var title = _ref.title,
    placement = _ref.placement,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Tooltip, _extends({}, restProps, {
    title: title,
    placement: placement
  }));
};
TooltipWrapper.propTypes = _objectSpread(_objectSpread({}, Tooltip.propTypes), {}, {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  label: PropTypes.string
});
TooltipWrapper.defaultProps = _objectSpread(_objectSpread({}, Tooltip.defaultProps), {}, {
  title: __('Untitled'),
  placement: 'top'
});
export default TooltipWrapper;